var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(_vm._s(_vm.$t('사업장 현황')))])
}
var staticRenderFns = []

export { render, staticRenderFns }